import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import sha256 from 'crypto-js/sha256';
import Base64 from 'crypto-js/enc-base64';

import ResetPasswordForm from './reset-password-form';
import { resetPassword } from '../actions/reset-password-actions';
import constants from '../../../../common/constants';

class ResetPassword extends Component {
  handleFormSubmit(values) {
    const verificationCode = this.props.params.code;
    const email = this.props.params.email;
    const password = sha256(constants.magic_salt + values.password).toString(Base64);

    const { resetPassword } = this.props;

    resetPassword(email, verificationCode, password);
  }

  render() {
    const { t } = this.context;

    return (
      <div className="login-container">
        <div className="login-container__wrapper">
          <div className="login-container__wrapper__main">
            <h2 className="text-center">{t('RESET_PASSWORD.TITLE')}</h2>
            <ResetPasswordForm btnText={'RESET_PASSWORD.SUBMIT_BTN'} handleFormSubmit={this.handleFormSubmit.bind(this)} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  resetPassword: (email, verificationCode, password) => {
    dispatch(resetPassword(email, verificationCode, password));
  },
});

ResetPassword.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);



// WEBPACK FOOTER //
// ./src/app/main/reset-password/components/reset-password.js